import axios from "axios";
import secureLocalStorage from "react-secure-storage";

export async function GET_PUBLIC(api, param) {
  const parameter = param ?? "";
  try {
    const response = await axios(
      `${process.env.REACT_APP_API_URL}${api}${parameter}`,
      {
        headers: {
          "Content-Type": "application/json",
          token: process.env.REACT_APP_API_KEY,
        },
        method: "get",
      }
    );
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else if (
      response.data.message === "Session inactive" ||
      response.data.message === "Token cannot be empty" ||
      response.data.message === "An error while decoding token" ||
      response.data.message === "Provided token is expired"
    ) {
      localStorage.clear();
      return {};
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    if (error.response.data.code === 401) {
    } else if (
      error.response.data.message === "Session inactive" ||
      error.response.data.message === "Token cannot be empty" ||
      error.response.data.message === "An error while decoding token" ||
      error.response.data.message === "Provided token is expired"
    ) {
    }
    return null;
  }
}

export async function GET(api, param) {
  const token = secureLocalStorage.getItem("token");
  const parameter = param ?? "";
  try {
    const response = await axios(
      `${process.env.REACT_APP_API_URL}${api}${parameter}`,
      {
        headers: {
          "Content-Type": "application/json",
          "token-auth": token,
          token: process.env.REACT_APP_API_KEY,
        },
        method: "get",
      }
    );
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else if (
      response.data.message === "Session inactive" ||
      response.data.message === "Token cannot be empty" ||
      response.data.message === "An error while decoding token" ||
      response.data.message === "Provided token is expired"
    ) {
      localStorage.clear();
      return {};
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    if (error.response.data.code === 401) {
    } else if (
      error.response.data.message === "Session inactive" ||
      error.response.data.message === "Token cannot be empty" ||
      error.response.data.message === "An error while decoding token" ||
      error.response.data.message === "Provided token is expired"
    ) {
    }
    return null;
  }
}

export async function POST_PUBLIC(api, datas) {
  try {
    const response = await axios(`${process.env.REACT_APP_API_URL}${api}`, {
      headers: {
        "Content-Type": "application/json",
        token: process.env.REACT_APP_API_KEY,
      },
      method: "post",
      data: JSON.stringify(datas),
    });
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else if (
      response.data.message === "Session inactive" ||
      response.data.message === "Token cannot be empty" ||
      response.data.message === "An error while decoding token" ||
      response.data.message === "Provided token is expired"
    ) {
      return {};
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    if (error.response.data.code === 401) {
    } else if (
      error.response.data.message === "Session inactive" ||
      error.response.data.message === "Token cannot be empty" ||
      error.response.data.message === "An error while decoding token" ||
      error.response.data.message === "Provided token is expired"
    ) {
    }
    return null;
  }
}

export async function POST(api, datas) {
  const token = secureLocalStorage.getItem("token");
  try {
    const response = await axios(`${process.env.REACT_APP_API_URL}${api}`, {
      headers: {
        "Content-Type": "application/json",
        "token-auth": token,
        token: process.env.REACT_APP_API_KEY,
      },
      method: "post",
      data: JSON.stringify(datas),
    });
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else if (
      response.data.message === "Session inactive" ||
      response.data.message === "Token cannot be empty" ||
      response.data.message === "An error while decoding token" ||
      response.data.message === "Provided token is expired"
    ) {
      return {};
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    if (error.response.data.code === 401) {
    } else if (
      error.response.data.message === "Session inactive" ||
      error.response.data.message === "Token cannot be empty" ||
      error.response.data.message === "An error while decoding token" ||
      error.response.data.message === "Provided token is expired"
    ) {
    }
    return null;
  }
}

export async function PUT(api, datas) {
  const token = secureLocalStorage.getItem("token");
  try {
    const response = await axios(`${process.env.REACT_APP_API_URL}${api}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      method: "put",
      data: JSON.stringify(datas),
    });
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else if (
      response.data.message === "Session inactive" ||
      response.data.message === "Token cannot be empty" ||
      response.data.message === "An error while decoding token" ||
      response.data.message === "Provided token is expired"
    ) {
      return {};
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    if (error.response.data.code === 401) {
    } else if (
      error.response.data.message === "Session inactive" ||
      error.response.data.message === "Token cannot be empty" ||
      error.response.data.message === "An error while decoding token" ||
      error.response.data.message === "Provided token is expired"
    ) {
    }
    return null;
  }
}

export async function POST_FILE(api, data) {
  const token = process.env.REACT_APP_API_KEY;
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/${api}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: token,
        },
      }
    );
    if (response.data.code === 200) {
      const data = response.data;
      return data;
    } else if (
      response.data.message === "Session inactive" ||
      response.data.message === "Token cannot be empty" ||
      response.data.message === "An error while decoding token"
    ) {
      return {};
    } else {
      throw new Error("Request failed");
    }
  } catch (error) {
    if (error.response.data.code === 401) {
    }
    return null;
  }
}
